<template>
    <section class="page-not-found page pt-5">
        <article>
            <div class="container">
                <h1 class="text-center mb-5">
                    404
                </h1>
                <h5 class="text-center">
                    The page you are looking for was moved, removed, renamed or might never existed.
                </h5>
                <div class="d-flex justify-content-center">
                    <router-link :to="{name: 'home'}" class="btn btn-default btn-lg btn-lg m-5">Go Home</router-link>
                </div>
            </div>
        </article>
    </section>
</template>

<script>
    export default {
        name: 'PageNotFound',
    };
</script>

<style lang="scss">
    @import '../scss/variables';

    .page-not-found {
        background: #EDEDED;
    }
</style>
